export const MainData = {
    "mainLogo": "/base/Luxintrip(Green).svg",
    "dict": [
        {
            "title": "En",
            "filename": "en",
            "countryName": "GB",
            "dir": "ltr",
            "default": true
        },
        {
            "title": "Fa",
            "filename": "fa",
            "countryName": "IR",
            "dir": "rtl",
            "default": false
        }
    ],
    "nav": [
        {
            "route": "",
            "title": {
                "fa": "خانه",
                "en": "Home"
            }
        },
        {
            "route": "/tour",
            "title": {
                "fa": "مقصد تور",
                "en": "Tour destination"
            }
        },
        {
            "route": "/visa-service",
            "title": {
                "fa": "خدمات ویزا",
                "en": "Visa Services"
            }
        },
        {
            "route": "/travel-agency",
            "title": {
                "fa": "آژانس مسافرتی",
                "en": "Travel agencies"
            }
        },
        {
            "route": "/tour-operator",
            "title": {
                "fa": "کارگزار تور",
                "en": "Tour operators"
            }
        },
        {
            "route": "/business",
            "title": {
                "fa": "پنل سازمانی",
                "en": "Organizational panel"
            }
        },
        {
            "route": "/buy-tour",
            "title": {
                "fa": "درخواست تور",
                "en": "Request tour"
            }
        },
    ],
    "footer": [
        {
            "route": "",
            "title": {
                "fa": "خانه",
                "en": "Home"
            }
        },
        {
            "route": "/tour",
            "title": {
                "fa": "مقصد تور",
                "en": "Tour destination"
            }
        },
        {
            "route": "/visa-service",
            "title": {
                "fa": "خدمات ویزا",
                "en": "Visa Services"
            }
        },
        {
            "route": "/travel-agency",
            "title": {
                "fa": "آژانس مسافرتی",
                "en": "Travel agencies"
            }
        },
        {
            "route": "/tour-operator",
            "title": {
                "fa": "کارگزار تور",
                "en": "Tour operators"
            }
        },
        
        
        {
            "route": "/business",
            "title": {
                "fa": "پنل سازمانی",
                "en": "Organizational panel"
            }
        },
        {
            "route": "/privacy-policy",
            "title": {
                "fa": "حریم خصوصی",
                "en": "Privacy Policy"
            }
        },
        {
            "route": "/contactus",
            "title": {
                "fa": "تماس باما",
                "en": "Contact Us"
            }
        },
        {
            "route": "/aboutus",
            "title": {
                "fa": "درباره ما",
                "en": "About Us"
            }
        },
        {
            "route": "https://www.aparat.com/luxintrip/videos",
            "target": "_blank",
            "title": {
                "fa": "ویدیوهای آموزشی",
                "en": "Educational videos"
            }
        },
        {
            "route": "/installapp",
            "title": {
                "fa": "اپلیکیشن لوکسین تریپ",
                "en": "Luxin Trip application"
            }
        },
        {
            "route": "/buy-tour",
            "title": {
                "fa": "درخواست تور",
                "en": "Request tour"
            }
        },
    ],
    "login": {
        "title": {
            "fa": "ورود",
            "en": "Login"
        },
        "ctas": [
            {
                "icon": "/base/dash.svg",
                "title": {
                    "fa": "پروفایل",
                    "en": "Profile"
                },
                "premission": [],
                "route": "/profile/dashboard",
            },
            {
                "icon": "/base/login.svg",
                "title": {
                    "fa": "خروج",
                    "en": "Logout"
                },
                "route": "/logout",
            }
        ]
    },
    "texts": {
        "footer-desc": {
            "fa": "لوکسین تریپ یک پلتفرم پیشرو  بین المللی برای همکاری در صنعت گردشگری است. این پلتفرم متعهد به ارائه راه‌حل‌های نوآورانه و با کیفیت بالا است که به آژانس‌ها و کارگزاران در هر اندازه‌ای کمک می‌کند تا به پتانسیل کامل خود برسند.",
            "en": "Luxin Trip is a leading international platform for collaboration in  tourism industry. The platform is committed to delivering innovative, high-quality solutions that help agencies and brokers of all sizes reach their full potential."
        },
        "footer-links-title": {
            "fa": "لینک ها",
            "en": "LINKS"
        },
        "footer-contactus-title": {
            "fa": "ارتباط با ما",
            "en": "CONTACT US"
        },
        "footer-findus-title": {
            "fa": "ما کجاییم",
            "en": "FIND US"
        },
        "address": {
            "fa": "ایران، تهران، خیابان شریعتی، کوچه مینوی، پلاک 731 ،واحد 1",
            "en": "Unit 1, No 731,At the corner of Minavi St, Shariati Ave, Tehran, Iran"
        },
        "phone": {
            "fa": "+98 (21) 88147216 , +98 (21) 88147635",
            "en": "+98 (21) 88147216 , +98 (21) 88147635"
        },
        "email": {
            "fa": "info@farazandishan.com",
            "en": "info@farazandishan.com"
        },
        "working hour": {
            "fa": "شنبه - چهارشنبه: ۹ صبح - ۵ بعد از ظهر",
            "en": "Saturday—Wednesday: 9:00AM-5:00PM"
        },
        "copyright": {
            "fa": "تمامی حقوق متعلق به شرکت فرازاندیشان می باشد",
            "en": "Copyright - Faraz Andishan Human Recource Company"
        },
        "language": {
            "fa": "زبان",
            "en": "language"
        }
    }
}